// extracted by mini-css-extract-plugin
var _1 = "Notifications_author__VHRZB";
var _2 = "Notifications_board__BN-gr";
var _3 = "Notifications_date__Gj0K5";
var _4 = "Notifications_firstItemButton__u7H1l";
var _5 = "Notifications_item__lejGq";
var _6 = "Notifications_itemButton__Zc1FT";
var _7 = "Notifications_itemContent__glztO";
var _8 = "Notifications_itemFullScreen__jQz0T";
var _9 = "Notifications_itemHeader__TmgY-";
var _a = "Notifications_itemRead__RDKEA";
var _b = "Notifications_project__Sf4NC";
var _c = "Notifications_user__hj4uB";
var _d = "Notifications_wrapper__EHJBh";
export { _1 as "author", _2 as "board", _3 as "date", _4 as "firstItemButton", _5 as "item", _6 as "itemButton", _7 as "itemContent", _8 as "itemFullScreen", _9 as "itemHeader", _a as "itemRead", _b as "project", _c as "user", _d as "wrapper" }
